const hasInfo = obj =>
  Object.values(obj).some(val => ![null, undefined, ''].includes(val));

export { hasInfo };
